import { useEffect, useState } from "react";
import api from "@/lib/api";
import { KpiCard, PageHeader, Panel } from "@/components/admin/shared";
import { ResponsiveContainer, FunnelChart, Funnel, LabelList, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, Cell } from "recharts";
import { CHART_COLORS } from "@/lib/constants";

export default function Walking() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/analytics/walking").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="py-20 text-center text-slate-400">Loading…</div>;

  const funnel = [
    { name: "Walking Visitors", value: d.total },
    { name: "→ Enquiry", value: d.to_enquiry },
    { name: "→ Trial", value: d.to_trial },
    { name: "→ Conversion", value: d.to_conversion },
  ];

  return (
    <div>
      <PageHeader title="Walking Analytics" subtitle="Are walkers converting into Oneiros customers?" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <KpiCard testid="walk-kpi-total" label="Total Walkers" value={d.total} accent="#081226" />
        <KpiCard testid="walk-kpi-first" label="First-time Walkers" value={d.first_time} accent="#0284C7" />
        <KpiCard testid="walk-kpi-returning" label="Returning Walkers" value={d.returning} accent="#E8752A" />
        <KpiCard testid="walk-kpi-convrate" label="Walker Conversion" value={`${d.conv_rate}%`} accent="#10B981" />
      </div>
      <div className="grid lg:grid-cols-2 gap-5">
        <Panel title="Walking → Conversion Funnel">
          <ResponsiveContainer width="100%" height={300}>
            <FunnelChart>
              <Tooltip />
              <Funnel dataKey="value" data={funnel} isAnimationActive>
                <LabelList position="right" fill="#334155" stroke="none" dataKey="name" fontSize={12} />
                <LabelList position="center" fill="#fff" stroke="none" dataKey="value" fontSize={14} fontWeight={700} />
                {funnel.map((e, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
              </Funnel>
            </FunnelChart>
          </ResponsiveContainer>
        </Panel>
        <Panel title="Walker Journey Breakdown">
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={[{ n: "Enquiry", v: d.to_enquiry }, { n: "Trial", v: d.to_trial }, { n: "Membership", v: d.to_conversion }]}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" /><XAxis dataKey="n" tick={{ fontSize: 12 }} /><YAxis tick={{ fontSize: 11 }} allowDecimals={false} /><Tooltip />
              <Bar dataKey="v" radius={[6, 6, 0, 0]}>{[0, 1, 2].map((i) => <Cell key={i} fill={CHART_COLORS[i]} />)}</Bar>
            </BarChart>
          </ResponsiveContainer>
        </Panel>
      </div>
    </div>
  );
}
